export default {
	common: {
		apply: 'Ok',
		cancel: 'Annuleren',
	},
	validation: {
		patternMismatch: 'Dit veld bevat ongeldige tekens',
		rangeOverflow: 'De opgegeven waarde is te hoog',
		rangeUnderflow: 'De opgegeven waarde is te laag',
		stepMismatch: 'De opgegeven waarde valt niet binnen de mogelijke stappen',
		tooLong: 'De opgegeven waarde is te lang',
		tooShort: 'De opgegeven waarde is te kort',
		typeMismatch: 'De opgegeven waarde heeft niet het juiste type',
		valueMissing: 'Dit veld mag niet leeg zijn',
	},
	zdsAdvancedSelect: {
		noResults: 'Geen resultaten',
		deleteItemLabel: 'Verwijder item',
		clearInputLabel: 'Wis invoer',
		closeSelectionLabel: 'Sluit itemselectie',
	},
	zdsAppbar: {
		searchPlaceholder: 'Zoeken',
	},
	zdsCalendar: {
		time: 'Tijd',
		previousMonthLabel: 'Vorige maand',
		nextMonthLabel: 'Volgende maand',
	},
	zdsContentReveal: {
		showLess: 'Toon minder',
		showMore: 'Toon meer',
	},
	zdsInputDate: {
		invalidDate: 'Dit is geen geldige datum ({{format}})',
		dateTooEarly: 'De datum mag niet eerder zijn dan {{minDate}}',
		dateTooLate: 'De datum mag niet later zijn dan {{maxDate}}',
		dateNotAvailable: 'De geselecteerde datum is niet beschikbaar',
		dateCannotBeHoliday: 'De datum mag geen nationale feestdag zijn',
		dateCannotBeInWeekend: 'De datum mag niet in het weekend liggen',
		openCalendarLabel: 'Open kalender',
	},
	zdsNavigation: {
		skipToContent: 'Direct naar hoofdinhoud',
	},
	zdsPagination: {
		ariaLabel: 'Pagina navigatie',
		ariaNextLabel: 'Volgende pagina',
		ariaPreviousLabel: 'Vorige pagina',
		ariaPagePrefix: 'Pagina {{pageIndex}}',
	},
	zdsUpload: {
		dropAFileHere: 'Sleep een bestand hierheen',
		or: 'of',
		selectAFile: 'Selecteer een bestand',
		fileSelected: 'bestand geselecteerd',
		filesSelected: 'bestanden geselecteerd',
		maxFilesReached: 'Maximaal aantal bestanden bereikt',
		validation: {
			fileSizeExceeded: 'Bestandsgrootte ({{filesize}} MB) overschrijdt het maximum: {{maxFilesize}} MB',
			fileTypeNotSupported: 'Bestandstype wordt niet ondersteund, gebruik: {{fileTypes}}',
			responseError: 'Er ging iets fout met de upload, probeer het later opnieuw',
			maxOneFile: 'Er mag slechts 1 bestand worden geselecteerd',
			maxFilesExceeded: 'Er mogen slechts {{maxFiles}} bestanden worden geselecteerd',
			fileSizeTotalExceeded:
				'De totale bestandsgrootte ({{totalFileSize}} MB) overschrijdt het maximum van {{maxTotalFileSize}} MB',
			badFileResponse: 'Er ging iets fout met de upload',
		},
		labels: {
			download: 'Download bestand',
			delete: 'Verwijder bestand',
		},
	},
	zdsInputRecipient: {
		invalidEmail: '"{{value}}" is geen geldig e-mailadres',
		removeChipLabel: 'Verwijder ontvanger',
	},
	zdsVideo: {
		playLabel: 'Video afspelen',
	},
	zdsTabs: {
		labels: {
			scrollLeft: 'Scroll naar links',
			scrollRight: 'Scroll naar rechts',
		},
	},
	zdsTab: {
		moreTabsLabel: 'Meer tabbladen',
	},
	zdsSideSheet: {
		labels: {
			collapse: 'Vouw zijmenu in',
			resize: 'Herformatteer menu',
		},
	},
	zdsNavigationPanel: {
		backLabel: 'Teruggaan',
		closeLabel: 'Sluiten',
	},
	zdsInputTime: {
		clockLabel: 'Open tijdsuggesties',
	},
	zdsInputPassword: {
		showPasswordLabel: 'Toon wachtwoord',
		hidePasswordLabel: 'Verberg wachtwoord',
	},
	zdsInputContentContainer: {
		rejectLabel: 'Afwijzen',
		acceptLabel: 'Accepteren',
		clearLabel: 'Wis invoer',
	},
	zdsDrawer: {
		closeLabel: 'Sluiten',
	},
	zdsDataTable: {
		sortLabel: 'Sorteer tabel',
	},
	zdsChip: {
		deleteLabel: 'Verwijder chip',
	},
	zdsCarousel: {
		closeFullscreen: 'Sluit de fullscreen-modus',
		slideLeftLabel: 'Schuif naar links',
		slideRightLabel: 'Schuif naar rechts',
	},
};
